import Restore from "@mui/icons-material/Restore";
import { Button } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

export const RevertToOriginalButton: FC<{
  contentTypeName: string;
  handleRevert: () => void;
  disabled: boolean;
}> = ({ contentTypeName, handleRevert, disabled }) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="text"
      startIcon={<Restore />}
      onClick={handleRevert}
      disabled={disabled}
      data-analytics-id="revert-to-original-images"
    >
      {contentTypeName.toLowerCase() === "video"
        ? t("Revert to original videos")
        : t("Revert to original images")}
    </Button>
  );
};
